<div class="organisation-container">
	<div class="heading">
		<app-page-title title="Organisation"></app-page-title>
		<app-step-navigator [stepConfig]="stepConfig"></app-step-navigator>
	</div>
	<div class="content">
		<router-outlet></router-outlet>
	</div>
</div>
